import { Link, usePage } from "@inertiajs/react"
import { inertiaUrlPathname } from "@/lib/utils"

export function SectionTabs({ tabs, className = "" }) {
  const { url } = usePage()
  const pathname = inertiaUrlPathname(url)

  const matchesPath = (href) => pathname === href || pathname.startsWith(href + "/")

  // Active = matches with longest prefix among siblings.
  // Prevents /articles/pending_review from also lighting up the /articles tab.
  const isActive = (tab) => {
    if (!matchesPath(tab.href)) return false
    return !tabs.some(
      (other) =>
        other.href !== tab.href &&
        other.href.length > tab.href.length &&
        matchesPath(other.href)
    )
  }

  return (
    <div className={`border-b border-zinc-200 ${className}`}>
      <nav className="-mb-px flex gap-6 overflow-x-auto" aria-label="Section tabs">
        {tabs.map((tab) => {
          const active = isActive(tab)
          return (
            <Link
              key={tab.href}
              href={tab.href}
              className={`whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors ${
                active
                  ? "border-kf-red text-zinc-900"
                  : "border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-700"
              }`}
            >
              {tab.label}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
